export default {"src":"/assets/_next/static/media/no-results-image.67147e2a.svg","height":124,"width":124,"blurWidth":0,"blurHeight":0};